module.exports = __webpack_public_path__ + "static/media/cart-plus.e3fc2c1a.svg";